import { ROLE_TYPE } from '@/api/type/commonTypes';
import { PostCenterSignUpRequest } from '@/api/type/types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface PhoneNumberFiledProps {
  phoneCode: string;
  formData: PostCenterSignUpRequest;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const CenterPhoneNumberFiled = ({
  phoneCode,
  onChange,
  formData,
}: PhoneNumberFiledProps) => {
  const { t } = useTranslation();
  return (
    <>
      <FormGroup>
        <Label $required>{t('common.mobileNumber')}</Label>
        <Row>
          <Input
            type="text"
            value={phoneCode}
            readOnly
            style={{
              width: '70px',
              textAlign: 'center',
              background: '#f5f5f5',
            }}
          />
          <Input
            type="tel"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={onChange}
            placeholder={t('signUp.numberOnly')}
            style={{ flex: 1 }}
            required
          />
        </Row>
      </FormGroup>
      <FormGroup>
        <Label $required>{t('centerSignUp.r2CenterName')}</Label>
        <Input
          type="text"
          name="centerName"
          value={formData.centerName}
          onChange={onChange}
          placeholder={t('centerSignUp.centerNamePlaceholder')}
          required
        />
      </FormGroup>
      <FormGroup>
        <Label $required>{t('centerSignUp.r2CenterPhoneNumber')}</Label>
        <Row>
          <Input
            type="text"
            value={phoneCode}
            readOnly
            style={{
              width: '70px',
              textAlign: 'center',
              background: '#f5f5f5',
            }}
          />
          <Input
            type="text"
            name="centerContactNumber"
            value={formData.centerContactNumber}
            onChange={onChange}
            placeholder={t('signUp.numberOnly')}
            style={{ flex: 1 }}
            required
          />
        </Row>
      </FormGroup>
    </>
  );
};

export default CenterPhoneNumberFiled;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

interface LabelProps {
  $required?: boolean;
}

const Label = styled.label<LabelProps>`
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;

  &::after {
    content: ${(props) => (props.$required ? "' *'" : "''")};
    color: #ff4d4f;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
`;

interface InputProps {
  $error?: boolean;
}

const Input = styled.input<InputProps>`
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid ${({ $error }) => ($error ? '#ef4444' : '#d9d9d9')};
  border-radius: 6px;
  outline: none;
  transition: all 0.2s;

  &:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;
